<template>
	<div>
		<div class="d-flex align-items-center justify-content-between mb16">
			<Icon v-if="isMobile" name="arrow-left" class="pointer" @click="close" />
			<h4 class="text-black neue fw-medium mb-0 lh28 pr24 fsp20" :class="{ 'flex-grow-1 text-center': isMobile }">
				{{ $t('views.Echeck.Activate.8') }}
			</h4>
			<Icon v-if="!isMobile" name="close" class="pointer" @click="close" />
		</div>
		<div class="bg-white rounded12" :class="{ 'p24': !isMobile }">
			<div class="d-flex mb16" :class="isMobile ? 'flex-column gap8' : 'align-items-center gap16'">
				<div class="d-flex align-items-center" :class="{ 'field-label': !isMobile }">
					<span class="fsp14 neue-roman lh20 text-black">{{ $t('views.Echeck.Activate.4') }}<span class="require"> *</span></span>
				</div>
				<InputSimple
					type="text"
					id="serial"
					:dataValue="data.serial"
					@updateParentState="updateState"
				/>
			</div>
			<div class="d-flex mb16" :class="isMobile ? 'flex-column gap8' : 'align-items-center gap16'">
				<div class="d-flex align-items-center" :class="{ 'field-label': !isMobile }">
					<span class="fsp14 neue-roman lh20 text-black">{{ $t('views.Echeck.Activate.3') }}<span class="require"> *</span></span>
				</div>
				<InputSimple
					type="text"
					id="number"
					:dataValue="data.number"
					@updateParentState="updateState"
				/>
			</div>
			<div class="d-flex mb16" :class="isMobile ? 'flex-column gap8' : 'align-items-center gap16'">
				<div class="d-flex align-items-center" :class="{ 'field-label': !isMobile }">
					<span class="fsp14 neue-roman lh20 text-black">{{ $t('views.Echeck.Activate.5') }}<span class="require"> *</span></span>
				</div>
				<InputSimple
					type="text"
					id="code"
					:dataValue="data.code"
					@updateParentState="updateState"
				/>
			</div>
			<div class="d-flex mb16" :class="isMobile ? 'flex-column gap8' : 'align-items-center gap16'">
				<div class="d-flex align-items-center" :class="{ 'field-label': !isMobile }">
					<span class="fsp14 neue-roman lh20 text-black">{{ $t('views.Echeck.Activate.2') }}<span class="require"> *</span></span>
				</div>
				<SelectSimple
					id="keyt"
					:keyt="true"
					:isSearch="true"
					:searchType="'curr'"
					:dataValue="data.keyt"
					:keywords.sync="keyts"
					@updateParentState="updateState"
				/>
			</div>
			<div v-if="preview" class="preview-card mb16">
				<div class="d-flex align-items-center justify-content-between">
					<span class="fsp14 neue-roman primary-grey">{{ $t('views.Echeck.Activate.9') }}</span>
					<span class="fsp14 neue fw-medium text-black">{{ preview.amount }} {{ preview.curr }}</span>
				</div>
				<div class="d-flex align-items-center justify-content-between">
					<span class="fsp14 neue-roman primary-grey">{{ $t('views.Echeck.Activate.11') }}</span>
					<span class="fsp14 neue fw-medium text-black">{{ statusText }}</span>
				</div>
			</div>
			<div class="d-flex gap-2 mt24" :class="{ 'mobile-modal-buttons': isMobile }">
				<Button
					@click="CheckEcheck"
					:name="$t('views.Echeck.Activate.6')"
					:disabled="!data.number || !data.serial || !data.code || checking || activating"
					:loader="checking"
					class="h48 equal-width"
					type="btn-outline-warning"
				/>
				<Button
					@click="ActiveEcheck"
					:name="$t('views.Echeck.Activate.7')"
					:disabled="!isDis() || activating || checking"
					:loader="activating"
					class="h48 equal-width"
					type="btn-warning"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from '@/components/icons/Icon';
import Button from '@/components/service/Button';
import SelectSimple from '@/components/service/SelectSimple';
import InputSimple from '@/components/service/InputSimple';

export default {
	components: {
		Icon,
		Button,
		InputSimple,
		SelectSimple,
	},
	props: {
		close: [Function],
	},
	data() {
		return {
			data: {
				serial: '',
				number: '',
				code: '',
				keyt: '',
			},
			keyts: [],
			preview: null,
			checking: false,
			activating: false,
		};
	},
	computed: {
		isMobile() {
			return this.$store.state.resize.w <= 768;
		},
		statusText() {
			if (!this.preview) return '';
			const key = 'views.Echeck.Activate.status.' + this.preview.status;
			const txt = this.$t(key);
			// vue-i18n возвращает ключ при отсутствии перевода — тогда показываем сырой статус
			return txt === key ? this.preview.status : txt;
		},
		t() {
			let k = this.$store.getters.get_keyts_keywords;
			if (k.length > 0) {
				this.getKeyts(k);
			}
			return k;
		},
	},
	watch: {
		t: {
			handler: function (newData) {
				this.getKeyts(newData);
			},
			deep: true,
		},
	},
	methods: {
		getKeyts(k) {
			this.keyts = k;
		},
		updateState(state) {
			this.data[state.id] = state.value;
		},
		isDis() {
			return this.data.code && this.data.keyt && this.data.number && this.data.serial;
		},
		CheckEcheck() {
			// Предпросмотр: секрет (code) обязателен для msEcheck
			this.checking = true;
			this.axios.post('CheckEcheck', { loader: 'own', data: { serial: this.data.serial, number: this.data.number, code: this.data.code } }).then(res => {
				// result приходит числом 0 при успехе (msEcheck KernelResponse → PHP passthrough).
				if (String(res.data.body.result) !== '0') {
					this.preview = null;
					return;
				}
				const table = Object.values(res.data.body.tables || {})[0];
				this.preview = (table && table.colvalues ? table.colvalues[0] : null) || null;
			}).finally(() => {
				this.checking = false;
			});
		},
		ActiveEcheck() {
			this.$store.dispatch('openModal', {
				action: true,
				type: 'pay_pass',
				content: {
					callback: () => {
						// In-flight (activating) приходит как result 0 — успех «деньги в полёте»;
						// updating.keyts применяется глобально ($lib). result_text покажет статус.
						this.activating = true;
						this.axios.post('ActiveEcheck', { loader: 'mini', data: this.data }).then(res => {
							if (String(res.data.body.result) !== '0') {
								return;
							}
							const listCallback = this.$store.state.modal.content?.callback;
							if (listCallback) {
								listCallback();
							}
							this.close();
						}).finally(() => {
							this.activating = false;
						});
					},
				},
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.field-label {
	width: 136px;
	flex-shrink: 0;
}

.preview-card {
	background: $bg-light-blue;
	border: 1px solid $primary-stroke;
	border-radius: 8px;
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

</style>
